module.exports = __webpack_public_path__ + "static/media/md-cloud-done.ebcd53f3.svg";